export default __webpack_public_path__ + "static/media/family8.ddc8449d.svg";